export default "__VITE_ASSET__aa6f3343__"